/**
 * catalog-view — `/sites/` の表示形式トグル（Grid / Compact）
 *
 * - 切り替えは **CSS クラス（`data-sp-view` 属性）のみ**。DOM は作り直さない
 *   → `view_item_list` が二重発火しない（list-tracking.js は再描画時のみ再送）。
 * - 選択は localStorage（`sitepick_sites_view`）に保存し、次回来訪時に復元。
 *   個人情報ではない。URL パラメータにはしない（SEO URL を増やさない）。
 * - ファセットの再描画（facet.js の `sitepick:content:updated`）でグリッドが
 *   差し替わっても、保存値を再適用する。
 */

const KEY = "sitepick_sites_view";
const DEFAULT_VIEW = "grid";

function readSaved() {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === "compact" || v === "grid" ? v : DEFAULT_VIEW;
  } catch {
    return DEFAULT_VIEW;
  }
}

function save(view) {
  try {
    window.localStorage.setItem(KEY, view);
  } catch {
    /* private mode 等。保存できなくても動作する。 */
  }
}

export function initCatalogView(root = document) {
  const group = root.querySelector(".js-sp-catalog-view");
  const grid = root.querySelector(".js-sp-catalog-grid");
  if (!group || !grid) {
    return;
  }

  function apply(view, persist) {
    const v = view === "compact" ? "compact" : "grid";
    const currentGrid = root.querySelector(".js-sp-catalog-grid");
    if (currentGrid) {
      currentGrid.setAttribute("data-sp-view", v);
    }
    root.querySelectorAll(".js-sp-catalog-view [data-sp-view-set]").forEach((btn) => {
      btn.setAttribute("aria-pressed", String(btn.getAttribute("data-sp-view-set") === v));
    });
    if (persist) {
      save(v);
    }
  }

  apply(readSaved(), false);

  group.addEventListener("click", (event) => {
    const btn = event.target instanceof Element ? event.target.closest("[data-sp-view-set]") : null;
    if (!btn) {
      return;
    }
    apply(btn.getAttribute("data-sp-view-set"), true);
  });

  // ファセット再描画後もビューを維持（グリッド / トグルが差し替わっている場合がある）。
  document.addEventListener("sitepick:content:updated", () => {
    apply(readSaved(), false);
  });
}
